import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * @typedef Props
 * @prop {string} [className]
 * @prop {boolean} [show]
 * @prop {boolean} [fullscreen]
 */
/**
 * @param {Props & {[x: string]: any;}} props
 */
const MotifProgressLoader = (props) => {
  const { className = '', show = false, fullscreen = false, ...other } = props;
  const classes = classNames({
    'motif-progress-loader': true,
    'motif-progress-loader-container': true,
    'motif-progress-loader-fullscreen': fullscreen,
    [className]: true
  });

  return (
    <React.Fragment>
      {show && (
        <div {...other} className={classes} data-motif-progress-loader>
          <div className="motif-progress-loader-content">
            <div className="motif-progress-loader-square" />
            <div className="motif-progress-loader-square" />
            <div className="motif-progress-loader-square" />
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

MotifProgressLoader.propTypes = {
  className: PropTypes.string,
  show: PropTypes.bool,
  fullscreen: PropTypes.bool
};

export { MotifProgressLoader };
